export const PLUGIN_NAME = 'auth-abacus-fe';
export const PROVIDER_KEY = 'blaze_auth_abacus';
export const PROVIDER_NAME = 'Blaze auth abacus';
export const GRAPH_QL_ERROR = 'GraphQL error: ';
export const PASSWORD_CONFIRM_MESSAGE = 'Passwords must match';
export const PASSWORD_VALIDATION_MESSAGE = 'Must contain 8 or more characters with a mix of upper & lower case letters, numbers & symbols and no spaces';
export const PASSWORD_REGEX = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,}$/;
export const EMAIL = 'email';
export const PASSWORD = 'password';
export const LOGIN_FORM = 'loginForm';
export const COOKIE_KEY = 'ADFEAuthCookie';
export const PASSWORD_RESET_REQUEST_COMPONENT_NAME = 'abacus-password-reset-request';
//# sourceMappingURL=constants.js.map